import { useEffect, useState } from 'react';
import { t } from '../../i18n/pt';
import styles from './CookieBanner.module.scss';

const STORAGE_KEY = 'rosita.cookies.consent';

type Choice = 'accepted' | 'rejected' | 'essential';

export function CookieBanner(): JSX.Element | null {
  const [choice, setChoice] = useState<Choice | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'accepted' || stored === 'rejected' || stored === 'essential') {
      setChoice(stored);
    } else {
      setVisible(true);
    }
  }, []);

  const save = (c: Choice): void => {
    localStorage.setItem(STORAGE_KEY, c);
    setChoice(c);
    setVisible(false);
  };

  if (!visible || choice !== null) return null;

  return (
    <div className={styles.banner} role="dialog" aria-live="polite">
      <div className={styles.inner}>
        <div>
          <h3 className={styles.title}>{t.cookies.title}</h3>
          <p className={styles.body}>{t.cookies.body}</p>
        </div>
        <div className={styles.actions}>
          <button className={styles.secondary} onClick={() => save('rejected')}>
            {t.cookies.reject}
          </button>
          <button className={styles.secondary} onClick={() => save('essential')}>
            {t.cookies.manage}
          </button>
          <button className={styles.primary} onClick={() => save('accepted')}>
            {t.cookies.accept}
          </button>
        </div>
      </div>
    </div>
  );
}
